import {SavePrint} from "pixi-save-print";
import * as printJS from "print-js";
import {Application} from "../Application";
import {Container} from "../core/Container";
import {Callback} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import {Assets} from "../data/Assets";
import {LevelNumber} from "../data/LevelModel";
import {Location, LocationPostcardLayout} from "../data/Location";
import {Postcard} from "./Postcard";

export class PrintablePostcard extends Container {

    public readonly background = this.addChild(new Sprite(Assets.postcardPrintable.getAsset()));
    public readonly postcard: Postcard;

    public readonly location: Location;
    public readonly level: LevelNumber;

    private _savePrint?: SavePrint;

    constructor(location: Location, level: LevelNumber) {
        super();
        this.location = location;
        this.level = level;
        this.postcard = this.addChild(new Postcard(location, level));
        LocationPostcardLayout[location]![level]!.call(this);
        this.postcard.revealItems();
        this.postcard.scale.set(0.74);
        this.postcard.x = this.background.width * 0.5;
        this.postcard.y = this.background.height * 0.516;
    }

    public render(cb?: Callback) {
        if (!this._savePrint) {
            this._savePrint = new SavePrint(this, Application.instance.renderer);
        }
        this._savePrint.render(cb);
    }

    public save() {
        if (this._savePrint) {
            this._savePrint.save(`${this.location} postcard ${this.level}.png`);
        }
    }

    public print() {
        if (this._savePrint) {
            printJS({
                printable: this._savePrint.canvas!.toDataURL(),
                type: "image",
                documentTitle: "Luna's Postcards Around the World",
            });
        }
    }
}
